import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useUrlGenerator } from '@micromag/core/contexts';
import { FormattedMessage } from 'react-intl';
import { Button } from '@micromag/core/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

import TeamMembers from '../partials/TeamMembers';
import AddButton from '../buttons/Add';
import { useOrganisation } from '../../contexts/OrganisationContext';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const OrganisationMenubar = ({ className }) => {
    const url = useUrlGenerator();
    const organisation = useOrganisation();
    // @TODO verify permissions
    const { permissions: organisationPermissions = null } = organisation || {};
    const { can_edit_team: canEditTeam = false, can_edit_story: canEditStory = false } =
        organisationPermissions || {};

    return (
        <div
            className={classNames([
                'row',
                'align-items-center',
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className="col py-1 py-sm-0">
                <TeamMembers organisation={organisation} withoutAdd={!canEditTeam} random />
            </div>
            <div className="col-auto py-1 py-sm-0">
                <Button
                    href={url('organisations.settings')}
                    theme="secondary"
                    outline
                    className="me-2 mt-2 mb-2"
                    icon={<FontAwesomeIcon icon={faCog} color="currentColor" />}
                >
                    <FormattedMessage
                        defaultMessage="Organisation settings"
                        description="Button label"
                    />
                </Button>
                {canEditStory ? (
                    <AddButton href={url('stories.create')} className="me-2 mt-2 mb-2">
                        <FormattedMessage
                            defaultMessage="New micromag"
                            description="Button label"
                        />
                    </AddButton>
                ) : null}
            </div>
        </div>
    );
};

OrganisationMenubar.propTypes = propTypes;
OrganisationMenubar.defaultProps = defaultProps;

export default OrganisationMenubar;
